import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import {catchError, switchMap, mergeMap, map} from 'rxjs/operators';
import { RmService } from '@bidi/common-services';
import {
  CommentsResourcesActionTypes,
  GetCommentsResourcesSuccess,
  GetCommentsResourcesFailure,
  SetCommentsResourcesSavedSuccess,
  LoadingComments,
  GetCommentsResources
} from './actions';

@Injectable()
export class CommentsResources {
  constructor (
    private actions$: Actions,
    private rm: RmService
  ) {
  }

  @Effect()
  getComments$: Observable<any> = this.actions$.pipe(
    ofType(CommentsResourcesActionTypes.GET_COMMENTS_RESOURCES),
    mergeMap<any, any>(({ payload }) =>
      this.rm.getComments(payload).pipe(
        switchMap(res => of(
          new GetCommentsResourcesSuccess({res}),
          new LoadingComments(false)
        )),
        catchError(err => of(
          new GetCommentsResourcesSuccess({}),
          new LoadingComments(false)
        ))
      )
    )
  );

  @Effect()
  setComments$: Observable<any> = this.actions$.pipe(
    ofType(CommentsResourcesActionTypes.SET_COMMENTS_RESOURCES_SAVED),
    switchMap<any, any>(({ payload }) =>
      this.rm.setComments(payload).pipe(
        switchMap((res) => of(
          new GetCommentsResources(payload.resource)
        )),
        catchError(err => of(
          new GetCommentsResourcesFailure(err),
          new LoadingComments(false)
        ))
      )
    )
  );
}
